import { mutatorAction } from 'satcheljs';
import store from '../store/Store';
import { DESCRIPTION_MAX_LENGTH } from '../constants/descriptionConstants';

/**
 * Action to update the service description in the store.
 */
export default mutatorAction(
    'SET_PBP_MEETING_TYPE_DESCRIPTION',
    function setMeetingTypeDescription(newServiceDescription: string) {
        store.meetingTypeEditState.description = newServiceDescription;
        store.meetingTypeEditState.validateDescription.hasError =
            newServiceDescription.length > DESCRIPTION_MAX_LENGTH;
    }
);
